import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=06a65a36&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=ts"
export * from "./orderList.vue?vue&type=script&lang=ts"
import style0 from "./orderList.vue?vue&type=style&index=0&id=06a65a36&prod&lang=scss&scoped=true"
import style1 from "./orderList.vue?vue&type=style&index=1&id=06a65a36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a65a36",
  null
  
)

export default component.exports